import { GLOBAL } from 'saddlebag-browser';

const cookieExists = (name: string): boolean => {
  const substring = `${name}=`;
  const doc = GLOBAL.getDocument() as Document;
  return (doc.cookie || '')
    .split(';')
    .some((item: string) => item.includes(substring));
};

export default cookieExists;
